import { useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import type { Swiper as SwiperType } from 'swiper';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import {
  MONTHLY_RECOMMENDED_TITLE,
  useMonthlyRecommendedRecipesQuery,
} from '../../../../api/recipe/hooks/useMonthlyRecommendedRecipesQuery';
import pcLeftArrow from '../../../../asset/svg/pc-left-slick-arrow.svg';
import pcRightArrow from '../../../../asset/svg/pc-right-slick-arrow.svg';
import SpaceY from '../../../../components/SpaceY';
import { MAX_WIDTH_639PX } from '../../../../utils/common';
import { useGetThisWeekVegetables } from '../../../../utils/hook/recipe';
import LoadingPage from '../../../LoadingPage';
import MoreRecipeLink from '../components/MoreRecipeLink';
import RecommendRecipeCard from '../RecommendRecipeCard';

import OriginalRecipeCurationSlide from './OriginalRecipeCurationSlide';

import 'swiper/css';
import 'swiper/css/autoplay';

const MonthlyRecommendedRecipeCuration = () => {
  const { thisWeekVegetables } = useGetThisWeekVegetables();
  const isMobile = useMediaQuery({ query: MAX_WIDTH_639PX });
  const swiperRef = useRef<SwiperType | null>(null);

  const slideCount = isMobile ? 1 : 2;

  const handleSlider = (direction: 'prev' | 'next') => () => {
    if (swiperRef.current) {
      if (direction === 'prev') {
        swiperRef.current.slidePrev();
      } else {
        swiperRef.current.slideNext();
      }
    }
  };

  const { monthlyRecommendedRecipes, isPending } =
    useMonthlyRecommendedRecipesQuery();

  if (isPending) return <LoadingPage />;

  if (monthlyRecommendedRecipes.length === 0) return null;

  return (
    <div className="px-16px">
      <MoreRecipeLink title={MONTHLY_RECOMMENDED_TITLE} link="/recipes" />
      <SpaceY height="16px" />
      {isMobile ? (
        <OriginalRecipeCurationSlide
          recipes={monthlyRecommendedRecipes}
          thisWeekVegetables={thisWeekVegetables}
          curationTitle={MONTHLY_RECOMMENDED_TITLE}
        />
      ) : (
        <div id="recipe-main-slick" className="relative">
          <Swiper
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            modules={[Autoplay]}
            loop={true}
            slidesPerView={slideCount}
            spaceBetween={16}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
          >
            {monthlyRecommendedRecipes.map((recipe, i) => (
              <SwiperSlide key={i}>
                <RecommendRecipeCard
                  recipe={recipe}
                  thisWeekVegetables={thisWeekVegetables}
                  noAnimation
                  onClick={() => {}}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <button
            className="absolute left-0 top-1/2 z-10 hidden px-19px sm:block"
            style={{ transform: 'translateY(-50%)' }}
            onClick={handleSlider('prev')}
            type="button"
          >
            <img src={pcLeftArrow.src} alt="left" />
          </button>
          <button
            className="absolute right-0 top-1/2 z-10 hidden px-19px sm:block"
            style={{ transform: 'translateY(-50%)' }}
            onClick={handleSlider('next')}
            type="button"
          >
            <img src={pcRightArrow.src} alt="right" />
          </button>
        </div>
      )}
    </div>
  );
};

export default MonthlyRecommendedRecipeCuration;
